import { Component } from 'react'
import moment from 'moment'

/**
 * 倒计时
 */
export default class TimeCount extends Component {
  static defaultProps = {
    endTime: '',
    onEnd: null // 计时结束的回调
  }

  state = {
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  }

  timer

  componentDidMount() {
    this.setTimer()
  }

  componentWillUnmount() {
    clearInterval(this.timer)
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.endAt !== this.props.endAt) {
      this.setTimer()
    }
  }

  setTimer = () => {
    clearInterval(this.timer)
    // const endTime = '2020-04-03 15:23:22'
    const endTime = this.props.endTime
    if (moment(endTime).diff(moment()) > 0) {
      this.countHandler()
      this.timer = setInterval(() => {
        this.countHandler()
      }, 1000)
    }
  }

  countHandler = () => {
    const endTime = this.props.endTime
    const diff = moment(endTime).diff(moment())

    if (diff > 0) {
      const duration = moment.duration(diff)
      const days = duration.days()
      const hours = duration.hours()
      const minutes = duration.minutes()
      const seconds = duration.seconds()

      this.setState({
        days,
        hours,
        minutes,
        seconds
      })
    } else {
      clearInterval(this.timer)
      this.setState({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
      })
      const { onEnd } = this.props
      // 计时结束
      onEnd && onEnd()
    }
  }

  render() {
    const { days, hours, minutes, seconds } = this.state
    const { children } = this.props
    return (
      (!!days || !!hours || !!minutes || !!seconds) &&
      children(days, fixTime(hours), fixTime(minutes), fixTime(seconds))
    )
  }
}

function fixTime(time) {
  return time < 10 ? `0${time}` : time
}
